import React from 'react'
import styled from 'styled-components'

import { API_BASE_URL } from '@mote/config/constants'

import { getUserId } from '../../../shared/Auth'

export const DownloadCSVTemplateButton = () => {
  return (
    <DownloadTemplateLink
      href={`${API_BASE_URL}t/getTemplateCSV?userId=${getUserId()}`}
    >
      Download Template
    </DownloadTemplateLink>
  )
}

const DownloadTemplateLink = styled.a`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: right;
  color: #ac0ae8;

  &:focus,
  &:hover,
  &:active {
    color: #ac0ae8;
  }
`
